import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/** Подвал: происхождение системы и служебные ссылки. */
const FULL_HEIGHT_ROUTES = ['/workspace'];

function Footer() {
  const { pathname } = useLocation();
  // На экранах во всю высоту (рабочее пространство) подвал только мешает
  if (FULL_HEIGHT_ROUTES.some((route) => pathname.startsWith(route))) return null;

  return (
    <footer style={{
      borderTop: '1px solid var(--gray-100)',
      background: '#fff',
      marginTop: 'var(--s-7)',
      padding: 'var(--s-5) var(--s-5) var(--s-6)',
    }}>
      <div style={{
        maxWidth: 1240, margin: '0 auto', display: 'flex', alignItems: 'center',
        gap: 'var(--s-4)', flexWrap: 'wrap',
      }}>
        <a href="https://scilibai.ru" target="_blank" rel="noreferrer"
           style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--gray-500)' }}>
          <img src="/scilib-mark.svg" alt="SciLib" style={{ height: 30, width: 'auto' }} />
          <span style={{ fontSize: 'var(--text-sm)' }}>Сделано в лаборатории SciLib</span>
        </a>

        <div style={{ flex: 1 }} />

        <div style={{ display: 'flex', gap: 'var(--s-4)', fontSize: 'var(--text-sm)', flexWrap: 'wrap' }}>
          <Link to="/about" style={{ color: 'var(--gray-500)' }}>О системе</Link>
          <Link to="/course" style={{ color: 'var(--gray-500)' }}>Программа курса</Link>
          <span className="meta">
            Формальная верификация и ИИ-инструменты математика · ФПМИ МФТИ
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
